import { SoundByte } from "../../enum/sounds";
import { Input, KeyCode } from "../../lib/Input";
import MonoBehavior from "../../lib/MonoBehavior";
import { Time } from "../../lib/Time";
import { Physics } from "../../math/Physics";
import Color from "../../util/Color";
import SoundManager from "../SoundManager";
import SPAbility from "../SPAbility";
import SPBogey from "../SPBogey";
import SPBullet from "../SPBullet";
import SPPlayer from "../SPPlayer";

export class ForceFieldBehavior extends MonoBehavior {
    size: number = 1;
    color: Color = new Color(255,80,80);
    hp: number = 5;
    isPlayers: boolean = false;
    timer: number = 5;

    Damage(amt: number = 1) {
        this.hp -= amt;
        SoundManager.Singleton.PlaySound(SoundByte.BulletHit);
        if (this.hp <= 0) {
            this.Die();
        }
    }

    Die() {
        SoundManager.Singleton.PlaySound(SoundByte.Break);
        this.gameObject.RemoveScript(this.id);
    }

    Update(): void {
        if (this.isPlayers) {
            this.timer -= Time.deltaTime;

            if (this.timer <= 0) {
                this.Die();
                return;
            }
        }
        
        for (const bullet of this.engine.GetGameObjectsBehaviors<SPBullet>(SPBullet).filter(
            v => this.isPlayers ? !v.isPlayerBullet : v.isPlayerBullet
        )) {
            if (Physics.CircleCircleCollision({
                position: this.transform.position,
                radius: this.size
            }, {
                position: bullet.transform.position,
                radius: bullet.size
            }) !== false) {
                bullet.Die();
                this.Damage(bullet.damage);
            }
        }

        if (this.isPlayers) {
            for (const bogey of this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey)) {
                if (Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: this.size
                }, {
                    position: bogey.transform.position,
                    radius: bogey.size
                }) !== false) {
                    bogey.Die();
                    this.Die();
                }
            }
        }
    }

    Draw(): void {
        const pos = this.engine.toScreenPosition(this.transform.position);
        const g = this.ctx.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, this.size);
        g.addColorStop(0, 'transparent');
        g.addColorStop(1, this.color.toHex());
        this.ctx.fillStyle = g;
        this.engine.FillCircle(this.transform.position, this.size);
    }
}

export default class ForceField extends SPAbility {

    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 30,
            duration: 0,
            icon: 1,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onUse(): void {
        this.player.gameObject.AddScript(ForceFieldBehavior, {
            size: this.player.size * 2,
            color: new Color(85,255,85),
            isPlayers: true
        });
    }

}